import React, { useEffect, useRef, useState } from "react";

import Logo from "../../assets/images/LogowithTagline.png";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../config/hooks";
import { tokenRepo } from "../../cache/db";
import { logout } from "../../slices/loginSlice";

import { persistor } from "../../store/store";
import { chatRoomActive } from "../../slices/chatSlice";
import Popup from "../popup/Popup";
import Login from "../login/Login";
import ConfirmationPopup from "../../modules/sales/ConfirmationPopup";
import { logoutComapany, switchLoginApi } from "../../slices/companySlice";

const Navbar = () => {
  const { pathname } = useLocation();
  const menuRef = useRef(null);
  const menuParentRef = useRef(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [toggleJoinAs, settoggleJoinAs] = useState(false);
  const [viewCompanyLinkPopup, setViewCompanyLinkPopup] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef();
  
  
  const loginSelector = useAppSelector((state) => state.login);

  const { session ,groupEmails} = loginSelector || {};

  // const emailInitial = session?.emaiId[0]?.toUpperCase();

  useEffect(() => {
    const toggleHandler = (e) => {
      if (
        menuRef.current &&
        menuParentRef &&
        !menuRef.current.contains(e.target) &&
        !menuParentRef.current.contains(e.target)
      ) {
        // close popup
        settoggleJoinAs(false);
      }
    };
    if (!session?.userId) {
      document.addEventListener("mousedown", toggleHandler);
    }

    return () => {
      if (!session?.userId) {
        document.removeEventListener("mousedown", toggleHandler);
      }
    };
  });

  const removeToken = async () => {
    try {
      await tokenRepo.appToken.delete(1);
      persistor.purge();
      dispatch(logout());

      // if (session?.userId) {
      //   if (session?.who === "user") {
      //     navigate("/");
      //     dispatch(logoutCandidateHandler());
      //     dispatch(removeCandidateDetails());
      //     // dispatch(logout());
      //   } else if (session?.who === "company") {
      //     navigate("/");
      //     dispatch(logoutComapany());
      //     dispatch(logoutCandidateHandler());
      //   } else if (session?.who === "company_member") {
      //     navigate("/");
      //     dispatch(logoutMember());
      //     dispatch(logoutCandidateHandler());
      //   } else if (session?.who === "recruiter") {
      //     navigate("/");
      //     dispatch(removeRecruiterDetails());
      //     dispatch(logoutCandidateHandler());
      //   }
      // }
    } catch (error) {}
  };

  // const navigateHandler = () => {
  //   navigate("/");
  // };

  const toggleJoinAsHandler = () => {
    if (session?.userId) {
      removeToken();
    } else {
      settoggleJoinAs(!toggleJoinAs);
    }
  };

  // const openChat=()=>{
  //   dispatch(chatRoomActive())
  // }

  const handleEmailChange = async (event) => {
    const currentEmail=session.emailId;
    const selectedEmail = event.target.value;
   
    try {
       
        // await dispatch(logoutComapany())
        await dispatch(switchLoginApi({currentEmail:currentEmail,targetEmail:selectedEmail}))
        .then(async()=>{
          // await dispatch(logoutComapany());
        //   setTimeout(()=>{
            window.location.reload();
        // },4000)
      })
    } catch (error) {
      console.error('Error during API call:', error);
    }
  };

  function getEmailInitials(email) {
    // Extract the domain from the email
    const emailDomain = email.split('@')[1]?.toLowerCase();
  
    // Initialize a variable to store the email initials
    let emailInitials = null;
  
    // Use switch-case to map the domain to initials
    switch (true) {
      case emailDomain?.includes("leadersedge"):
        emailInitials = "LE";
        break;
      case emailDomain?.includes("linkcxo"):
        emailInitials = "LX";
        break;
      case emailDomain?.includes("exotalent"):
        emailInitials = "ET";
        break;
      case emailDomain?.includes("gmail"):
        emailInitials = emailDomain;
        break;
      default:
        emailInitials = emailDomain[0]; // No match found
    }
  
    return emailInitials;
  }

 

  return (
    <div className="h-16 w-full bg-secondary-100 flex items-center justify-center shadow-md shadow-[#828282] z-10 relative">
      <div className="w-[98%] flex items-center justify-between mx-auto">
        <div className="w-fit">
          <img src={Logo} alt="Exotelent Logo" className="max-w-52" />
        </div>
        <div className="flex items-center justify-between gap-10 relative">
          <ul className="w-fit flex mr-0 ml-auto space-x-10 text-lg text-[#223870] font-medium">
            {!session?.userId && (
              <Link to={"/#about"} className={`cursor-pointer px-2`}>
                About Us
              </Link>
            )}

            {!session?.userId && (
              <Link to={"/#services"} className={`cursor-pointer px-2`}>
                Services
              </Link>
            )}
            {!session?.userId && (
              <Link to={"/#industry"} className={`cursor-pointer px-2`}>
                Industry Verticals
              </Link>
            )}
            {!session?.userId && (
              <Link to={"/#client"} className={`cursor-pointer px-2`}>
                Clients
              </Link>
            )}
            {session?.userId && session?.who === "user" && (
              <Link
                className={`cursor-pointer px-2 ${
                  pathname === "/job-search" &&
                  "font-bold border-b-2 border-b-expurple-800"
                }`}
                to="/job-search"
              >
                Jobs
              </Link>
            )}
            {session?.userId && session?.who === "recruiter" && (
              <Link
                className={`cursor-pointer px-2 ${
                  pathname === "/job-search" &&
                  "font-bold border-b-2 border-b-expurple-800"
                }`}
                to="/job-search"
              >
                Jobs
              </Link>
            )}
            {!session?.userId && (
              <Link
                className={`cursor-pointer px-2 ${
                  pathname === "/job-search" &&
                  "font-bold border-b-2 border-b-expurple-800"
                }`}
                to="/job-search"
              >
                Jobs
              </Link>
            )}
            {session?.userId && session?.who === "user" && (
              <Link
                className={`cursor-pointer px-2 ${
                  (pathname === "/applied-jobs" ||
                    pathname === "/member" ||
                    pathname === "/recruiter-dashboard") &&
                  "font-bold border-b-2 border-b-expurple-800"
                }`}
                to={"/applied-jobs"}
              >
                Profile
              </Link>
            )}

            {/* {session?.userId && groupEmails &&  (
              <div className="bg-transparent border-2 py-2  border-expurple-800 text-expurple-800 rounded-lg mr-2">
                <select onChange={handleEmailChange} defaultValue="" className="bg-transparent text-expurple-800 outline-none">
                <option value="" disabled>
                  Select an email
                </option>
                  {groupEmails.filter((ele)=>ele!==session.emailId).map((email, index) => (
                    <option key={index} value={email}>
                      {email}
                    </option>
                  ))}
                </select>
              </div>
            )} */}
          </ul>

          <div className=" relative w-fit space-y-1">
          {/* {session?.userId && groupEmails &&  (
              <div className="bg-transparent border-2 py-2  border-expurple-800 text-expurple-800 rounded-lg mr-2">
                <select onChange={handleEmailChange} className="bg-transparent text-expurple-800 outline-none">
                <option value="" disabled>
                  Select an email
                </option>
                  {groupEmails.filter((ele)=>ele!==session.emailId).map((email, index) => (
                    <option key={index} value={email}>
                      {email}
                    </option>
                  ))}
                </select>
              </div>
            )} */}
            {/* {session?.userId && <button onClick={()=>setViewCompanyLinkPopup(!viewCompanyLinkPopup)} className="bg-transparent border-2 px-8 py-2 border-expurple-800 text-expurple-800 rounded-lg mr-2">
              Link Company
            </button>}
            <button
              type="button"
              className={`w-40 px-8 py-2 rounded-lg ${
                session?.userId
                  ? "bg-transparent border-2 border-expurple-800 text-expurple-800"
                  : "bg-expurple-800 text-golden"
              }  text-center text-lg font-medium`}
              onClick={session?.userId?()=>setShowLogoutConfirm(true) :toggleJoinAsHandler}
              ref={menuParentRef}
            >
              {session?.userId ? "Logout" : "Login As"}
            </button> */}


            {session?.userId && (
            <div className="relative" ref={dropdownRef}>
              <div
                className="w-12 h-12 mr-2 rounded-full bg-expurple-800 text-white flex items-center justify-center text-2xl font-semibold cursor-pointer"
                onClick={() => setShowDropdown((prev) => !prev)}
              >
                {/* {session?.emailId[0]?.toUpperCase()} */}
                {session?.emailId ? getEmailInitials(session?.emailId) : ""}
              </div>

            {showDropdown && (
            <div className="absolute right-0 2xl:right-2 mt-2 mr-2  w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10">
             

              {groupEmails && groupEmails?.length > 1 && (
                <div className="py-2 px-2 hover:bg-gray-100 ">
                  <select
                    onChange={handleEmailChange}
                    defaultValue=""
                    className="w-full text-sm text-expurple-800 border border-gray-300 rounded  py-1 bg-white "
                  >
                    <option value="" disabled>
                     Change Company/User
                    </option>
                    {groupEmails
                      ?.filter((email) => email !== session.emailId)
                      .map((email, index) => (
                        <option key={index} value={email}>
                          {getEmailInitials(email)}
                        </option>
                      ))}
                  </select>
                </div>
              )}

              {pathname!="/employee-dashboard" && <button
                onClick={() => {
                  setViewCompanyLinkPopup(true);
                  setShowDropdown(false);
                }}
                className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
              >
                Link Company/User
              </button>}
              <button
                onClick={() => {
                  setShowLogoutConfirm(true);
                  setShowDropdown(false);
                }}
                className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      )}

      {!session?.userId && (
        <button
          type="button"
          className="w-40 px-8 py-2 rounded-lg bg-expurple-800 text-golden text-center text-lg font-medium"
          onClick={toggleJoinAsHandler}
          ref={menuParentRef}
        >
          Login As
        </button>
      )}


            {toggleJoinAs && !session?.userId && (
              <div
                className="absolute w-full bg-[#E0DFF4] rounded-lg overflow-hidden right-0"
                ref={menuRef}
              >
                <ul className="text-center text-lg text-expurple-700 font-medium flex flex-col">
                  <Link
                    to={"company"}
                    className="w-full px-5 py-3 hover:bg-expurple-800 hover:text-golden font-medium cursor-pointer border-b-2 border-exgray-100"
                    onClick={toggleJoinAsHandler}
                  >
                    Company
                  </Link>

                  <Link
                    to={"candidate"}
                    className="w-full px-5 py-3 hover:bg-expurple-800 hover:text-golden font-medium cursor-pointer"
                    onClick={toggleJoinAsHandler}
                  >
                    Candidate
                  </Link>
                  {/* <Link
                    to={"recruiter"}
                    className="w-full px-5 py-1 hover:bg-expurple-800 hover:text-golden font-medium cursor-pointer"
                    onClick={toggleJoinAsHandler}
                  >
                    Recruiter
                  </Link> */}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      <Popup
        visible={viewCompanyLinkPopup}
        onClose={()=>setViewCompanyLinkPopup(!viewCompanyLinkPopup)}
        isCloseButton={true}
        children={<Login
          title="Connect Company/User"
          redirectTo="/company/register"
          userType="companyLink"
          onClose={()=>setViewCompanyLinkPopup(!viewCompanyLinkPopup)}
        />}
        />

      <ConfirmationPopup
              visible={showLogoutConfirm}
              onClose={() => setShowLogoutConfirm(false)}
              onConfirm={toggleJoinAsHandler}
              message="Are you sure you want to Logout?"
      />
    </div>
  );
};
export default Navbar;
